import React, { FC, ComponentType } from 'react';
import { useTranslations, TranslationKey } from '@lang';
import { TypographySizes } from '@common/theme/theme.types';
import { TypographyGeneratorWrapper } from './TypographyGenarator.styles';

type TypographyGeneratorProps = {
  children?: React.ReactNode;
  tag?: string | ComponentType<any>;
  textId?: TranslationKey;
  strong?: boolean;
  uppercase?: boolean;
  color?: string;
  marginBottom?: string;
  font?: string;
  typographySizes: TypographySizes;
  className?: string;
};

export const TypographyGenerator: FC<TypographyGeneratorProps> = ({
  tag = 'span',
  textId,
  typographySizes,
  children,
  strong = false,
  uppercase = false,
  color,
  marginBottom = 0,
  font,
  className,
  ...props
}) => {
  const { t } = useTranslations();
  return (
    <TypographyGeneratorWrapper
      as={tag}
      typographySizes={typographySizes}
      strong={strong}
      uppercase={uppercase}
      colour={color}
      marginBottom={marginBottom}
      font={font}
      className={className}
      {...props}
    >
      {textId ? t(textId) : children}
    </TypographyGeneratorWrapper>
  );
};
